import { Collapse, Descriptions, Tag } from 'antd';
import FaIcon from '../../global/FaIcon';
import NextSpinner from '../NextSpinner';
import { useEffect, useState } from 'react';
import { useApproveTicketMutation } from '../../../app/features/approveTickets/approveTickets.api';
import { DetailTicket } from '../../../types/models/ticket.model.type';
import Link from 'antd/lib/typography/Link';
import {
  requestStatus,
  statusFilterRequests,
} from '../../../utils/mapping/statusRequests.mapping';
import { TRootStatus } from '../../../types/ux/status.ux.type';
import { useAppDispatch } from '../../../hooks/redux.hook';
import {
  DEFAULT_CONFIRM_ACCEPT,
  DEFAULT_CONFIRM_CANCEL,
  EMPTY_TEXT,
  STATUS_CODE_PENDING_APPROVE,
  STATUS_PENDING,
  STATUS_PENDING_APPROVE,
} from '../../../utils/enum/defaultParams.enum';
import {
  rxCloseModalTicketDetail,
  rxOpenModalTicketCancel,
  rxOpenModalTicketDetail,
  rxOpenModalTicketReassign,
  rxOpenModalTicketRejectAp,
  rxOpenModalTicketRejectAt,
  rxOpenModalTicketSolve,
} from '../../../app/features/sharedTickets/sharedTickets.slice';
import { ActionType } from '../../../types/states/ticket.state.type';
import {
  APPROVE_TICKETS,
  ATTEND_TICKETS,
  MY_TICKETS,
} from '../../../utils/enum/actionsTicket.enum';
import {
  rxOpenAlertModal,
  rxOpenConfirmModal,
} from '../../../app/features/common/common.slice';
import { Messages } from '../../../utils/mapping/messages.mapping';
import { ApproveTicketRequest } from '../../../types/request/ticket.request.type';
import { ApproveTicketResponse } from '../../../types/response/ticket.response.type';
import { useAuth } from '../../../hooks/useAuth.hook';
import { ERROR, SUCCESS } from '../../../utils/enum/responseStates.enum';
import { useSelector } from 'react-redux';
import { approveTicketsSelector } from '../../../app/features/approveTickets/approveTickets.slice';
import { getApprovedTickets } from '../../../app/features/approveTickets/approveTickets.thunk';

type Props = {
  ticket: DetailTicket;
  isLoading?: boolean | undefined;
  activePanel?: 'collapse' | '' | undefined;
  onCollapsed?: ((key: string | string[]) => void) | undefined;
  action: ActionType | undefined;
};

const NextCollapseTicket = ({
  ticket,
  isLoading = false,
  activePanel = EMPTY_TEXT,
  action,
}: Props) => {
  const dispatch = useAppDispatch();
  const { request: requestAt } = useSelector(approveTicketsSelector);
  const { user } = useAuth();
  const [activeKey, setActiveKey] = useState<string>(EMPTY_TEXT);
  const [approveTicket] = useApproveTicketMutation();

  const onOpenModalCancel = async () => {
    dispatch(rxCloseModalTicketDetail());
    dispatch(rxOpenModalTicketCancel(ticket));
  };
  const onOpenModalApprove = async () => {
    dispatch(rxCloseModalTicketDetail());
    dispatch(
      rxOpenConfirmModal({
        title: EMPTY_TEXT,
        message: Messages.approveTicketConfirm,
        callbackYes: () => onHandleApproveTicket(),
        callbackNo: () => onHandleCloseModalConfirm(),
        textButtonNo: DEFAULT_CONFIRM_CANCEL,
        textButtonYes: DEFAULT_CONFIRM_ACCEPT,
      })
    );
  };
  const onOpenModalRejectAp = async () => {
    dispatch(rxCloseModalTicketDetail());
    dispatch(rxOpenModalTicketRejectAp(ticket));
  };
  const onOpenModalRejectAt = async () => {
    dispatch(rxCloseModalTicketDetail());
    dispatch(rxOpenModalTicketRejectAt(ticket));
  };
  const onOpenModalReassign = async () => {
    dispatch(rxCloseModalTicketDetail());
    dispatch(rxOpenModalTicketReassign(ticket));
  };
  const onOpenModalSolve = async () => {
    dispatch(rxCloseModalTicketDetail());
    dispatch(rxOpenModalTicketSolve(ticket));
  };
  const onChangedKey = () => {
    if (activeKey === 'collapse') {
      setActiveKey(EMPTY_TEXT);
    } else {
      setActiveKey('collapse');
    }
  };
  const onHandleApproveTicket = async () => {
    const approveTicketRequest: ApproveTicketRequest = {
      pIdUsuario: user!.id.toString(),
      pIdTicket: `${ticket.periodo}-${ticket.idTicket}`,
      pIdDetTicket: ticket.idDetTicket,
    };
    const approveTicketResponse: ApproveTicketResponse = await approveTicket(
      approveTicketRequest
    ).unwrap();
    if (approveTicketResponse.isSuccess) {
      dispatch(
        rxOpenAlertModal({
          title: Messages.empty,
          message: approveTicketResponse.errorMessage,
          type: SUCCESS,
          callbackOk: () => {},
        })
      );
      dispatch(getApprovedTickets(requestAt!));
    } else {
      dispatch(
        rxOpenAlertModal({
          title: Messages.empty,
          message: approveTicketResponse.errorMessage,
          type: ERROR,
          callbackOk: () => {},
        })
      );
    }
  };
  const onHandleCloseModalConfirm = () => {
    dispatch(rxOpenModalTicketDetail());
  };

  const codeStatus = statusFilterRequests.filter(
    (w) => w.name === ticket.estado
  )[0].code;
  const status: TRootStatus = requestStatus[codeStatus];

  const codeStatusApprove = ticket.aprobacionTI
    ? statusFilterRequests.filter((w) => w.name === ticket.estadoAprob)[0].code
    : EMPTY_TEXT;
  const statusApprove: TRootStatus = ticket.aprobacionTI
    ? requestStatus[codeStatusApprove]
    : requestStatus['PE'];

  const downloadFile = (url: string) => {
    if (url.includes('.txt')) {
      fetch(url, {
        mode: 'no-cors',
      })
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = url.split('/').pop()!;
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => console.error(error));
    } else {
      window.open(url, '_blank');
    }
  };

  useEffect(() => {
    setActiveKey(activePanel);
  }, [activePanel]);

  return (
    <NextSpinner spinning={isLoading}>
      <div className="hover:ring-gray-200 ring-gray-100 ring-2 rounded-md bg-gray-50 mr-5 ml-5 mb-5 mt-3">
        <Collapse
          defaultActiveKey={activeKey}
          activeKey={activeKey}
          accordion
          expandIconPosition="end"
          onChange={onChangedKey}
        >
          <Collapse.Panel
            key="collapse"
            header={
              <>
                <div className="h-4 flex items-center">
                  <i className={`far fa-ticket mr-2`} />
                  <div className="font-semibold">{ticket.incidenciaDesc}</div>
                </div>
              </>
            }
            extra={
              <div className="h-4 flex items-center">
                <div className="font-semibold">Estado: {ticket.estado}</div>
              </div>
            }
          >
            <div className="px-6 pb-6 pt-2">
              <>
                <div className="flex justify-end">
                  {action === MY_TICKETS && ticket.estado === STATUS_PENDING ? (
                    <button
                      type="button"
                      onClick={onOpenModalCancel}
                      className="mr-2 inline-flex justify-center items-center rounded-md border border-transparent bg-red-100 px-4 py-2 text-sm font-medium text-red-900 hover:bg-red-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2"
                    >
                      <i className="far fa-xmark mr-2 fa-fw" />
                      Anular
                    </button>
                  ) : (
                    <></>
                  )}
                  {action === ATTEND_TICKETS &&
                  ticket.estado === STATUS_PENDING &&
                  ticket.idEstadoAprob !== STATUS_CODE_PENDING_APPROVE ? (
                    <button
                      type="button"
                      onClick={onOpenModalRejectAt}
                      className="mr-2 inline-flex justify-center items-center rounded-md border border-transparent bg-red-100 px-4 py-2 text-sm font-medium text-red-900 hover:bg-red-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2"
                    >
                      <i className="far fa-xmark mr-2 fa-fw" />
                      Rechazar
                    </button>
                  ) : (
                    <></>
                  )}
                  {action === ATTEND_TICKETS &&
                  ticket.estado === STATUS_PENDING &&
                  ticket.idEstadoAprob !== STATUS_CODE_PENDING_APPROVE ? (
                    <button
                      type="button"
                      onClick={onOpenModalSolve}
                      className="mr-2 inline-flex justify-center items-center rounded-md border border-transparent bg-green-100 px-4 py-2 text-sm font-medium text-green-900 hover:bg-green-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-green-500 focus-visible:ring-offset-2"
                    >
                      <i className="far fa-check mr-2 fa-fw" />
                      Resolver
                    </button>
                  ) : (
                    <></>
                  )}
                  {action === ATTEND_TICKETS &&
                  ticket.estado === STATUS_PENDING &&
                  ticket.idEstadoAprob !== STATUS_CODE_PENDING_APPROVE ? (
                    <button
                      type="button"
                      onClick={onOpenModalReassign}
                      className="inline-flex justify-center items-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                    >
                      <i className="far fa-arrows-retweet mr-2 fa-fw" />
                      Reasignar
                    </button>
                  ) : (
                    <></>
                  )}
                  {action === APPROVE_TICKETS &&
                  ticket.estado === STATUS_PENDING &&
                  ticket.estadoAprob === STATUS_PENDING_APPROVE ? (
                    <button
                      type="button"
                      onClick={onOpenModalApprove}
                      className="mr-2 inline-flex justify-center items-center rounded-md border border-transparent bg-green-100 px-4 py-2 text-sm font-medium text-green-900 hover:bg-green-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-green-500 focus-visible:ring-offset-2"
                    >
                      <i className="far fa-check mr-2 fa-fw" />
                      Aprobar
                    </button>
                  ) : (
                    <></>
                  )}
                  {action === APPROVE_TICKETS &&
                  ticket.estado === STATUS_PENDING &&
                  ticket.estadoAprob === STATUS_PENDING_APPROVE ? (
                    <button
                      type="button"
                      onClick={onOpenModalRejectAp}
                      className="mr-2 inline-flex justify-center items-center rounded-md border border-transparent bg-red-100 px-4 py-2 text-sm font-medium text-red-900 hover:bg-red-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2"
                    >
                      <i className="far fa-xmark mr-2 fa-fw" />
                      Rechazar
                    </button>
                  ) : (
                    <></>
                  )}
                </div>

                <Descriptions bordered title="Solicitud" size="small">
                  <Descriptions.Item span={3} label="N° Ticket">
                    <span className="font-bold">
                      #{ticket.periodo}-{ticket.idTicket.padStart(6, '0')}
                    </span>
                  </Descriptions.Item>
                  <Descriptions.Item label="Tema de Ayuda">
                    <span className="font-bold">{ticket.temaDesc}</span>
                  </Descriptions.Item>
                  <Descriptions.Item label="Módulo/Sistema">
                    <div className="text-center">
                      <span className="font-bold">{ticket.sistemaDesc}</span>
                    </div>
                  </Descriptions.Item>
                  <Descriptions.Item label="Estado">
                    <div className="text-center">
                      <span>
                        <Tag
                          className="w-full text-center"
                          color={status.bgColor}
                        >
                          {status.icon && (
                            <FaIcon icon={status.icon} classes="mr-2" />
                          )}
                          {status.label}
                        </Tag>
                      </span>
                    </div>
                  </Descriptions.Item>
                  <Descriptions.Item
                    label="Responsable"
                    span={ticket.aprobacionTI ? 1 : 1.5}
                  >
                    <div className="text-center">
                      <span className="font-bold">
                        {action === ATTEND_TICKETS
                          ? ticket.nombreCortoColab
                          : ticket.nombrecortoColab}
                      </span>
                    </div>
                  </Descriptions.Item>
                  <Descriptions.Item
                    label="Fecha y Hora de Registro"
                    span={ticket.aprobacionTI ? 1 : 1.5}
                  >
                    <div className="text-center">
                      <span className="font-bold">
                        {ticket.fechaRegistro} {ticket.horaRegistro}
                      </span>
                    </div>
                  </Descriptions.Item>
                  {ticket.aprobacionTI && (
                    <Descriptions.Item label="Estado Aprobación">
                      <div className="text-center">
                        <span>
                          <Tag
                            className="w-full text-center"
                            color={statusApprove.bgColor}
                          >
                            {statusApprove.icon && (
                              <FaIcon
                                icon={statusApprove.icon}
                                classes="mr-2"
                              />
                            )}
                            {statusApprove.label}
                          </Tag>
                        </span>
                      </div>
                    </Descriptions.Item>
                  )}
                  <Descriptions.Item label="Archivos Adjuntos" span={3}>
                    <div className="text-justify">
                      {ticket.imagen1 !== EMPTY_TEXT ? (
                        <Link onClick={() => downloadFile(ticket.imagen1)}>
                          Adjunto_Solicitud_001{' '}
                          <i className="prefix-icon far fa-link fa-fw fill text-blue-400" />
                        </Link>
                      ) : (
                        'No existen archivos adjuntos.'
                      )}
                      {ticket.imagen2 !== EMPTY_TEXT ? (
                        <>
                          <br />
                          <Link onClick={() => downloadFile(ticket.imagen2)}>
                            Adjunto_Solicitud_002{' '}
                            <i className="prefix-icon far fa-link fa-fw fill text-blue-400" />
                          </Link>
                        </>
                      ) : (
                        ' '
                      )}
                      {ticket.imagen3 !== EMPTY_TEXT ? (
                        <>
                          <br />
                          <Link onClick={() => downloadFile(ticket.imagen3)}>
                            Adjunto_Solicitud_003{' '}
                            <i className="prefix-icon far fa-link fa-fw fill text-blue-400" />
                          </Link>
                        </>
                      ) : (
                        ' '
                      )}
                    </div>
                  </Descriptions.Item>
                  <Descriptions.Item label="Comentarios" span={3}>
                    <div className="text-justify">
                      <span>{ticket.comentarios}</span>
                    </div>
                  </Descriptions.Item>
                </Descriptions>

                <Descriptions
                  bordered
                  className="mt-4"
                  title="Respuesta"
                  size="small"
                >
                  <Descriptions.Item
                    label="Archivos Adjuntos"
                    labelStyle={{ width: '20%' }}
                    contentStyle={{ width: '40%' }}
                    span={1.5}
                  >
                    <div className="text-justify">
                      {ticket.respImg1 !== EMPTY_TEXT ? (
                        <Link onClick={() => downloadFile(ticket.respImg1)}>
                          Adjunto_Respuesta_001{' '}
                          <i className="prefix-icon far fa-link fa-fw fill text-blue-400" />
                        </Link>
                      ) : (
                        'No existen archivos adjuntos.'
                      )}

                      {ticket.respImg2 !== EMPTY_TEXT ? (
                        <>
                          <br />
                          <Link onClick={() => downloadFile(ticket.respImg2)}>
                            Adjunto_Respuesta_002{' '}
                            <i className="prefix-icon far fa-link fa-fw fill text-blue-400" />
                          </Link>
                        </>
                      ) : (
                        ' '
                      )}

                      {ticket.respImg3 !== EMPTY_TEXT ? (
                        <>
                          <br />
                          <Link onClick={() => downloadFile(ticket.respImg3)}>
                            Adjunto_Respuesta_003{' '}
                            <i className="prefix-icon far fa-link fa-fw fill text-blue-400" />
                          </Link>
                        </>
                      ) : (
                        ' '
                      )}
                    </div>
                  </Descriptions.Item>
                  <Descriptions.Item
                    label="Fecha y Hora de Atención"
                    labelStyle={{ width: '20%' }}
                    contentStyle={{ width: '20%' }}
                    span={1.5}
                  >
                    <div className="text-center">
                      <span className="font-bold">
                        {ticket.fechaTermino
                          ? `${ticket.fechaTermino} ${ticket.horaTermino}`
                          : `-`}
                      </span>
                    </div>
                  </Descriptions.Item>
                  <Descriptions.Item label="Comentarios" span={3}>
                    <div className="text-justify">
                      <span>
                        {ticket.respuestaAtencion
                          ? ticket.respuestaAtencion
                          : '-'}
                      </span>
                    </div>
                  </Descriptions.Item>
                </Descriptions>
              </>
            </div>
          </Collapse.Panel>
        </Collapse>
      </div>
    </NextSpinner>
  );
};

export default NextCollapseTicket;
